@if (formattedPageSizeOptions) {
  <mat-paginator #producerProspectPaginator
    [length]="totalLength"
    [pageSize]="pageSize"
    [pageSizeOptions]="formattedPageSizeOptions"
    (page)="change($event)">
  </mat-paginator>
}
